import Box from "@mui/material/Box";
import CardGrid from "../../../shared/components/common/ui/CardGrid";

const IntegrationsAddContent = ({ templateData }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        minHeight: { sm: "calc(100vh - 120px)" },
      }}
    >
      <Box
        sx={{
          px: { xs: 2, sm: 3 },
          pb: { xs: 2, sm: 3 },
          display: "flex",
          flexDirection: "column",
          flex: 1,
        }}
      >
        <Box sx={{ width: "100%" }}>
          <CardGrid data={templateData} showText neutralArrow />
        </Box>
      </Box>
    </Box>
  );
};

export default IntegrationsAddContent;
